<template>
  <div :class="['swiper-slide', classes]" :style="currentVerticalGutter">
    <slot></slot>
  </div>
</template>

<script>
  import { fallback } from '@helpers/responsive-utilities'

  export default {
    name: 'CarouselItem',
    methods: {
      getSwiper() {
        return this.$parent.swiper
      }
    },
    computed: {
      classes () {
        return this.$parent.disabled ? this.$parent.disabledColClasses : null
      },
      currentVerticalGutter () {
        if (this.$parent.disabled) {
          const gutter = fallback(this.$parent.disabledColVerticalGutter, this.$parent.currentStep)
          return {paddingTop: `${gutter}px`, paddingBottom: `${gutter}px`}
        } else {
          return null
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "~$scss/_variables";
  // Theme: equal height
  .equal-height {
    height: auto;
  }
  .fullscreen {
    margin: 50px auto;
    width: 95%;
    @media(min-width:$bootstrap-md){
      margin: 40px auto;
      width: 70%;
    }
    @media(min-width:$bootstrap-lg){
      width: 80%;
    }
  }
</style>